import { client } from '../client';
import { ICase } from './types/ICase';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface AddAddtionalInfoPayload {
  additional_info: string;
}

export const addAdditionalInfo = async (
  case_id: number,
  payload: AddAddtionalInfoPayload,
  userRole?: string,
): Promise<ICase> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post(`${prefix}/cases/${case_id}/additional_info`, payload);

  return data;
};
